<svg:line
  *ngIf="points$ | async as points"
  class="outline vanishing-line"
  x1="-1"
  x2="999999"
  [attr.y1]="points[0][1]"
  [attr.y2]="points[0][1]"
/>
<svg:g
  (mousedown)="handleMouseEvent($event, 'shape')"
  (dblclick)="handleMouseEvent($event, 'shape')"
  (mouseup)="handleMouseEvent($event, 'shape')"
>
  <line
    *ngFor="let ends of backgroundEdgeEndpoints$ | async; trackBy: trackByIndex"
    class="outline"
    [attr.x1]="ends[0][0]"
    [attr.y1]="ends[0][1]"
    [attr.x2]="ends[1][0]"
    [attr.y2]="ends[1][1]"
  />
  <g
    h3ShapeFill
    class="primary-face"
    [points]="primaryFacePoints$ | async"
    [visibility]="visibility$ | async"
    [outline]="false"
    [scale$]="scale$"
  />
  <g
    h3ShapeFill
    [points]="topFacePoints$ | async"
    [visibility]="visibility$ | async"
    [outline]="false"
    [scale$]="scale$"
  />
  <g
    h3ShapeFill
    [points]="sideFacePoints$ | async"
    [visibility]="visibility$ | async"
    [outline]="false"
    [scale$]="scale$"
  />
  <line
    *ngFor="let ends of foregroundEdgeEndpoints$ | async; trackBy: trackByIndex"
    class="outline"
    [attr.x1]="ends[0][0]"
    [attr.y1]="ends[0][1]"
    [attr.x2]="ends[1][0]"
    [attr.y2]="ends[1][1]"
  />
</svg:g>
<svg:g
  *ngFor="let subpointInfo of allSubpointInfo$ | async; trackBy: trackByIndex"
  [h3Subpoint]="subpointInfo"
  [shapeSelected]="selected"
  (mousedown)="handleMouseEvent($event, 'subpoint', subpointInfo.subpointIndex)"
  (dblclick)="handleMouseEvent($event, 'shape')"
/>
